module.exports = __webpack_public_path__ + "19_pvis.jpg?24f16afbd01ef581619479b12453a79a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/19_pvis.jpg
// module id = 166
// module chunks = 0